import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-work-in-progress',
  templateUrl: './work-in-progress.component.html',
  styleUrls: []
})
export class WorkInProgressComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
